import { Modal } from '../../../components/modals/Modal';

export const NewPiecesNumberModal = ({ isOpen, setIsOpen, onConfirm, onCancel, data }) => {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} size="medium">
      <div className='p-4'>
        <h3 className='text-lg text-start font-medium leading-6 text-gray-900'>Confirmer le nombre de pièces</h3>
        <div className='my-4'>
          <p className='text-sm text-start text-gray-500'>
            {
              data?.pieces_number === undefined || data?.pieces_number === 0 ? "Aucune piece n'a été détectée dans l'image." :
              <>
                {
                  data?.pieces_number === 1 ? "1 pièce a été détectée"
                    : data.pieces_number + " pièces ont été détectées"
                }
                , ce qui est différent du nombre renseigné pour cette gamme.
              </>
            }
            <br/><br/>Souhaitez-vous tout de même utiliser cette gamme ?
          </p>
        </div>
        <div className='flex justify-start'>
          <button
            className='inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50'
            onClick={() => {
              if (onCancel !== undefined && onCancel !== null)
                onCancel();

              setIsOpen(false)
            }}
          >
            Retour
          </button>
          <button
            className='ml-4 inline-flex justify-center rounded-md border border-transparent bg-perception-blue px-4 py-2 text-sm font-medium text-white shadow-sm'
            onClick={() => {
              if (onConfirm !== undefined && onConfirm !== null)
                onConfirm();
              setIsOpen(false);
            }}
          >
            Continuer
          </button>
        </div>
      </div>
    </Modal>
  );
};
